import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MerkmalService } from 'app/core/services/merkmal/merkmal.service';
import * as MerkmalActions from './merkmal.actions';

@Injectable()
export class MerkmalEffects {
  constructor(
    private actions$: Actions,
    private merkmalService: MerkmalService,
  ) {}

  loadMerkmale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MerkmalActions.loadMerkmale),
      switchMap(() =>
        this.merkmalService.GetMerkmalTree().pipe(
          map(merkmale => MerkmalActions.loadMerkmaleSuccess({ merkmale })),
          catchError(() => of(MerkmalActions.loadMerkmaleError()))
        )
      )
    )
  );
}
